import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import {
  createPassenger,
  updatePassenger,
} from "shared/lib/golObjectTypes/Passenger/passenger";

import { ErrorBox, Form } from "@components/Profile/Forms/HooksForm";
import CollabsibleSection from "@components/UI/CollabsibleSection";
import Modal from "@components/UI/Modal";

import PassengerForm from "../Forms/PassengerForm";
import { LoyaltyCards } from "../LoyaltyCards";
import { PassportDocuments } from "../PassportDocuments";

type PassengerModalProps = {
  passengerForEdit?: any;
  show: boolean;
  onClose: () => void;
  setPassengerForRemoval?: (passenger: any) => void;
  defaultCountry: string;
};

export default function PassengerModal({
  passengerForEdit = {},
  show,
  onClose,
  defaultCountry,
  setPassengerForRemoval,
}: PassengerModalProps) {
  const initFormVals = {
    birthDate: "",
    email: "",
    givenName: "",
    namePrefix: "",
    surname: "",
    telephone: "",
    passports: [],
    loyalties: [],
  };

  const preparedFormVals =
    passengerForEdit === null ? initFormVals : passengerForEdit;

  const [formVals, setFormVals] = useState(preparedFormVals);
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!show) return null;
  const isNewPassenger = passengerForEdit === null;

  return (
    <Modal isActive={show} onClose={onClose}>
      <div className="profile-modal__container">
        <Form
          errors={errors}
          onSubmit={async (e) => {
            if (isSubmitting) {
              return;
            }

            setIsSubmitting(true);
            const onlyToValidate = e.nativeEvent.submitter.outerHTML.includes(
              "validate-button"
            );

            if (onlyToValidate) {
              return;
            }

            const res = isNewPassenger
              ? await createPassenger(formVals)
              : await updatePassenger(passengerForEdit.id, formVals);

            if (res.success) {
              setIsSubmitting(false);
              setSubmitError(null);
              onClose();
            } else {
              setIsSubmitting(false);
              setSubmitError(res.errorMsg);
            }
          }}
        >
          <h3 className="profile-modal__title">
            <FormattedMessage
              id={`Profile.${isNewPassenger ? "new" : "edit"}PassengerTitle`}
            />
          </h3>

          <CollabsibleSection title="General.travellers" id="travelers" state>
            <PassengerForm
              formVals={formVals}
              setFormVals={setFormVals}
              errors={errors}
              setErrors={setErrors}
            />
          </CollabsibleSection>

          <CollabsibleSection title="Form.passportInfo" id="passport">
            <PassportDocuments
              formVals={formVals}
              setFormVals={setFormVals}
              setErrors={setErrors}
              errors={errors}
              defaultCountry={defaultCountry}
            />
          </CollabsibleSection>

          <CollabsibleSection title="Profile.loyaltyCards" id="loyaltyCards">
            <LoyaltyCards
              formVals={formVals}
              setFormVals={setFormVals}
              setErrors={setErrors}
              errors={errors}
            />
          </CollabsibleSection>

          <ErrorBox submitError={submitError} />
          <div className="profile-modal__buttons">
            <button
              className="primary-button profile-modal__save-btn"
              type="submit"
              id="save-traveler-btn"
            >
              <FormattedMessage id="Profile.saveChanges" />
            </button>
            {!isNewPassenger &&
              !passengerForEdit?.isOwner &&
              setPassengerForRemoval && (
                <button
                  type="button"
                  className="profile-modal__open-remove-btn"
                  onClick={() => setPassengerForRemoval(passengerForEdit)}
                >
                  <FormattedMessage id="Profile.deleteTraveler" />
                </button>
              )}
          </div>
        </Form>
      </div>
    </Modal>
  );
}
